import { ClientAvatarType } from "@prisma/client";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useT } from "@/app/translations/useT";
import { UserClientAvatar } from "@/app/types/client-avatar/UserClientAvatar";
import { UStyles } from "@/app/utils/UStyles";
import AvatarDetail from "../../AvatarDetail/AvatarDetail";
import { AVATAR_TYPE_BADGE_CLASS, AVATAR_TYPE_LABEL } from "../Avatars.logic";
import styles from "../Avatars.module.css";
import AvatarCardMenu from "./AvatarCardMenu";
import AvatarFreshnessBadge from "./AvatarFreshnessBadge/AvatarFreshnessBadge";

type Props = {
  avatar: UserClientAvatar;
  lang: string;
  isPlaceholder?: boolean;
  isAnalyzing?: boolean;
  isStale?: boolean;
  onExtract?: (targetType: ClientAvatarType, isEnrich: boolean) => void;
};

export default function PrimaryCard(props: Props) {
  const T = useT();
  const canRunPaidActions = useCanRunPaidActions();
  const { avatar, lang, isPlaceholder, isAnalyzing = false, isStale = false, onExtract } = props;

  const isExtracted = avatar.id !== -1;

  return (
    <div className={UStyles.classNames(styles.primaryCard, isPlaceholder && styles.noHover)}>
      <div className={styles.cardHeader}>
        <span className={styles[AVATAR_TYPE_BADGE_CLASS[avatar.type]]}>
          {T(AVATAR_TYPE_LABEL[avatar.type])}
        </span>
        {!isPlaceholder && (
          <div className={styles.cardHeaderActions}>
            {isExtracted && canRunPaidActions && (
              <AvatarFreshnessBadge
                isStale={isStale}
                onEnrich={onExtract ? () => onExtract(avatar.type, true) : undefined}
              />
            )}
            <AvatarCardMenu params={{ lang }} avatar={avatar} onExtract={onExtract} />
          </div>
        )}
      </div>

      <div className={styles.primaryDetailContainer}>
        <AvatarDetail
          params={{ lang }}
          avatar={avatar}
          isPlaceholder={isPlaceholder}
          isAnalyzing={isAnalyzing}
        />
      </div>
    </div>
  );
}
